export const MainUrl = "/api";
export const CHKLevel = 1;
export const MNGLevel = 10;
export const ADirectorLevel = 11;
export const DirectorLevel = 12;
export const TYLevel = 20;
export const HRLevel = 30;
export const KADRLevel = 40;
export const ApprovedStatusId = 3;

export const MngGroupLevels = [MNGLevel, ADirectorLevel, DirectorLevel];
